const analyticsDashboard = {
  // overview
  title: "Analytics",
  dataRepresentedUpTo: "Data represented up to {{date}}",
  monthToDate: "Month-to-date",
  past12Months: "Past 12 months",
  current: "Current",
  noHistoricalDataAvailable: "No historical data available",

  financials: {
    title: "Financials",
    viewFinancialReports: "View financial reports",
    viewFinancialSettings: "View financial settings",
  },
  orders: {
    title: "Orders",
    viewAllOrders: "View all orders",
    ordersPlaced: "Orders placed",
  },
  plans: {
    title: "Plans",
    viewIndividualPlans: "View individual plans",
    viewMultiPatientPlans: "View multi-{{patientTerm}} plans",
  },
  autorefill: {
    title: "Auto refill",
  },
  tooltips: {
    sales:
      "Your account's total sales revenue (price paid by your {{patientTermPlural}}, including discounts)",
    profitMargin: "Your account's total earnings",
    ordersPlaced: "The number of orders placed by your {{patientTermPlural}}",
    orderingPatients: "The number of {{patientTermPlural}} who placed an order",
    plansActivated: "The number of individual plans activated",
    individualPlanConversionRate:
      "The proportion of individual {{patientTerm}} plans that had their first order within 30 days of being activated",
    autorefillRevenue:
      "Your account's sales revenue from orders that are a part of an auto refill subscription",
    firstTimeAutorefillPatients:
      "The number of {{patientTermPlural}} that have placed their first auto refill order",
    autorefillOrderRatio: "The number of orders fulfilled through an auto refill",
  },

  // details
  backToAnalytics: "Back to analytics",
  total: "Total",
  detailsPageTitle: {
    sales: "Sales",
    profitMargin: "Profit margin",
    ordersPlaced: "Orders placed",
    orderingPatients: "Ordering {{patientTermPlural}}",
    plansActivated: "Plans activated",
    individualPlanConversionRate: "Plan conversion",
    autorefillRevenue: "Auto refill sales",
    firstTimeAutorefillPatients: "First-time auto refills",
    autorefillOrderRatio: "Auto refill orders",
  },
  legendName: {
    treatmentPlanSales: "Individual plans",
    multiPatientPlanSales: "Multi-{{patientTerm}} plans",
    selfServeSales: "Self-serve",
    firstOrders: "First orders",
    repeatOrders: "Repeat orders",
    treatmentPlanProfit: "Individual plans profit",
    multiPatientPlanProfit: "Multi-{{patientTerm}} plans profit",
    selfServeProfit: "Self-serve profit",
    firstOrderingPatients: "First ordering {{patientTermPlural}}",
    repeatOrderingPatients: "Repeat ordering {{patientTermPlural}}",
  },
  legendContent: {
    treatmentPlanSales: "Sales from items that had an associated plan in the reference month",
    multiPatientPlanSales:
      "Sales from items that had an associated multi {{patientTerm}} plan in the reference month",
    selfServeSales:
      "Sales from items that did not have an associated plan or multi {{patientTerm}} plan in the reference month",
    firstOrders: "{{patientTermPluralCapitalized}} that have placed their first order",

    repeatOrders:
      "{{patientTermPluralCapitalized}} that are placing an order following their first order",
    treatmentPlanProfit: "Profit from items that had an associated plan in the reference month",
    multiPatientPlanProfit:
      "Profit from items that had an associated multi {{patientTerm}} plan in the reference month",
    selfServeProfit:
      "Profit from items that did not have an associated plan or multi {{patientTerm}} plan in the reference month",
    firstOrderingPatients: "{{patientTermPluralCapitalized}} that have placed their first order",
    repeatOrderingPatients:
      "{{patientTermPluralCapitalized}} that are placing an order following their first order",
  },
  legendDescription: {
    sales:
      "Your account's total sales revenue (price paid by your {{patientTermPlural}}, including discounts)",
    profitMargin: "Your account's total earnings",
    ordersPlaced: "Total number of orders placed by your {{patientTermPlural}}",
    orderingPatients: "The number of {{patientTermPlural}} who have placed an order",
    plansActivated: "The number of individual plans activated",
    individualPlanConversionRate:
      "The proportion of individual {{patientTerm}} plans that had their first order within 30 days of being activated",
    autorefillRevenue:
      "Your account's sales revenue from orders that are a part of an auto refill subscription",
    firstTimeAutorefillPatients:
      "The number of {{patientTermPlural}} that have placed their first auto refill order",
    autorefillOrderRatio: "The number of orders fulfilled through an auto refill",
  },

  // educational banner
  educationalBanner: {
    viewHandout: "View handout",
    learnMore: "Learn more",
    watchVideo: "Watch video",
    multiPatientPlanPlural: "multi-{{patientTerm}} plans",
    updatePermissions: "Update permissions",
    sales: {
      title: "Consider switching to an 'open' catalog",
      content:
        "{{patientTermPluralCapitalized}} can still follow your recommendations, while having the flexibility to purchase additional wellness products. Providers with an open catalog see 41.38% of sales from self-guided shopping.",
    },
    ordersPlaced: {
      title: "Drive {{patientTerm}} adherence with the Fullscript mobile app",
      content:
        "Keeping {{patientTermPlural}} on plan is the key to  better outcomes. Encourage {{patientTermPlural}} to use the Fullscript mobile app. Those who use it are 40% more likely to place their next order vs. web users.",
    },
    orderingPatients: {
      title: "Share multi-{{patientTerm}} plans to increase {{patientTerm}} engagement",
      content:
        "From seasonal concerns to general wellness, some protocols may benefit a wide range of {{patientTermPlural}}. Share them easily with your entire {{patientTerm}} list – or a specific group – via Fullscript. ",
    },
    plans: {
      title: "Drive {{patientTerm}} engagement and orders",
      content:
        "We've gathered proven tips and best practices designed to help you promote ongoing {{patientTerm}} engagement and increase adherence.",
    },
    individualPlanConversionRate: {
      title: "Strengthen your plans from the start",
      content:
        "Practitioners who use the product comparison feature regularly when building plans see, on average, higher order rates on their {{patientTerm}} plans. Compare products to find items that reflect unique {{patientTerm}} needs around price, format, and dietary preferences.",
    },
    firstTimeAutorefills: {
      title: "Increase auto refill rates with additional discounts",
      content:
        "Motivate your {{patientTermPlural}} to use auto refills by offering an additional incentive. {{patientTermPluralCapitalized}} with these discounts are 2X as likely to activate auto refill – which increases adherence by 28%.",
    },
    autoRefillOrders: {
      title: "Encourage your {{patientTermPlural}}  to set up auto refill",
      content:
        "{{patientTermPluralCapitalized}} with auto refill have increased plan adherence and are 3x more likely to place a second order. Share this handout with your {{patientTermPlural}}.",
    },
  },

  // educational margin profit card
  educationalMarginProfitCard: {
    subtitle: "Consider the benefits of a profit account",
    description:
      "With a profit account, you can offer greater {{patientTerm}} discounts while earning passive revenue to grow your practice. Check out the <revenueCalculator>revenue calculator</revenueCalculator> to see your practice's potential.",
    setUpProfitAccount: "Set up a profit account",
  },
} as const;

export { analyticsDashboard };
